var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 16.4375H5.25C2.5125 16.4375 0.9375 14.8625 0.9375 12.125V6.875C0.9375 4.1375 2.5125 2.5625 5.25 2.5625H12.75C15.4875 2.5625 17.0625 4.1375 17.0625 6.875V12.125C17.0625 14.8625 15.4875 16.4375 12.75 16.4375ZM5.25 3.6875C3.105 3.6875 2.0625 4.73 2.0625 6.875V12.125C2.0625 14.27 3.105 15.3125 5.25 15.3125H12.75C14.895 15.3125 15.9375 14.27 15.9375 12.125V6.875C15.9375 4.73 14.895 3.6875 12.75 3.6875H5.25Z",
    fill: "#38879F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 10.153C8.37008 10.153 7.73258 9.95797 7.24508 9.56047L4.89758 7.68547C4.65758 7.49047 4.61258 7.13796 4.80758 6.89796C5.00258 6.65796 5.35508 6.61297 5.59508 6.80797L7.94257 8.68297C8.51257 9.14047 9.48007 9.14047 10.0501 8.68297L12.3976 6.80797C12.6376 6.61297 12.9976 6.65046 13.1851 6.89796C13.3801 7.13796 13.3426 7.49797 13.0951 7.68547L10.7476 9.56047C10.2676 9.95797 9.63008 10.153 9.00008 10.153Z",
    fill: "#38879F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEmail);
export default __webpack_public_path__ + "static/media/user-email.aca90176e5a4c35b06699ebd2adf57aa.svg";
export { ForwardRef as ReactComponent };